/* angular:styles/component:css;d77bc6789c28dc44;/home/runner/work/app/app/src/app/components/org-tabs/org-tabs.component.ts */
:host {
  display: block;
  background: var(--background-color);
}
/*# sourceMappingURL=org-tabs.component-4JSZDU5D.css.map */
